/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    AmplifyEventBus,
    AmplifyPlugin
} from 'aws-amplify-vue'
import * as AmplifyModules from 'aws-amplify'
import store from '@/store'
import Buefy from 'buefy'

// ページコンポーネントをインポートする
import Auth from '@/views/Auth.vue'
import NotFound from '@/views/NotFound.vue'
import FlyerIndex from '@/views/Flyers/Index.vue'
import FlyerAdd from '@/views/Flyers/Add.vue'
import FlyerEdit from '@/views/Flyers/Edit.vue'
import FlyerView from '@/views/Flyers/View.vue'

Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(Buefy)

let user

// ユーザー管理
getUser().then(user => {
    if (user) {
        router.push({
            path: '/'
        })
    }
})

AmplifyEventBus.$on('authState', async state => {
    if (state === 'signedOut') {
        user = null
        router.push({
            path: '/auth'
        })
    } else if (state === 'signedIn') {
        user = await getUser()
        Vue.prototype.$buefy.toast.open({
            message: 'ログインしました',
            type: 'is-success'
        })
        router.push({
            path: '/'
        })
    }
})

function getUser() {
    return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
        .then(data => {
            if (data && data.signInUserSession) {
                store.commit('setUser', data)
                return data
            }
        })
        .catch(e => {
            console.log(e)
            store.commit('setUser', null)
            return null
        })
}

// VueRouterインスタンスを作成する
const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Index',
            component: FlyerIndex,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/auth',
            name: 'Auth',
            meta: {
                layout: 'none'
            },
            component: Auth
        },
        {
            path: '/flyers',
            name: 'FlyerIndex',
            component: FlyerIndex,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/flyers/add',
            name: 'FlyerAdd',
            component: FlyerAdd,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/flyers/edit/:id',
            name: 'FlyerEdit',
            component: FlyerEdit,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/flyers/view/:id',
            name: 'FlyerView',
            component: FlyerView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ]
})

router.beforeResolve(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        user = await getUser()
        if (!user) {
            Vue.prototype.$buefy.toast.open({
                message: 'ログインしてください',
                type: 'is-success'
            })

            return next({
                path: '/auth',
                query: {
                    redirect: '/'
                }
            })
        }
        return next()
    }
    return next()
})

export default router
